import {HOTEL_TYPE} from '@/models-hotel';

const hotelType: HOTEL_TYPE = 'P';
export const hotelName = 'P-LEISURE';
export default hotelType;
